<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div>
      <NavBarOnly></NavBarOnly>
      <div class="conteudo cor-secundaria-bg" style="position: unset;">
        <logo-empresa></logo-empresa>
        <br>
        <div class="row">
          <form class="col s12">
            <div class="row">
              <div class="input-field col s12">
                <i class="material-icons prefix splash-cor-1 ">person</i>
                <input id="icon_prefix" type="text" class="validate splash-cor-1" disabled v-bind:value="cliente.nome">
              </div>
              <div class="input-field col s12">
                <i class="material-icons prefix splash-cor-1">phone</i>
                <input id="icon_telephone" type="tel" class="validate splash-cor-1" disabled v-bind:value="cliente.telefone">
              </div>
            </div>
          </form>
        </div>
        <div class="btn waves-effect waves-light cor-primaria-bg" @click="UltimosPedidos()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              Meus Pedidos
            </div>
          </div>
        </div>
        <br>
        <div class="btn waves-effect waves-light red" @click="Sair()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              Deslogar de sua conta
            </div>
          </div>
        </div>
        <div style="height: 500px;"></div>
      </div>
    </div>
    <meu-login-bloco-flutuante-component></meu-login-bloco-flutuante-component>
  </div>
</template>

<script>
import NavBarOnly from "../../Widgets/NavBarOnly";
import LogoEmpresa from "../../Widgets/LogoEmpresa";
import {Logout, ObterClienteLogado} from "../../../services/auth";
import MeuLoginBlocoFlutuanteComponent from "../../Widgets/MeuLoginBlocoFlutuanteComponent";
import axios from "axios";

export default {
  name: "PerfilCliente",
  data(){
    return{
      cliente:{
        nome:"",
        email:"",
        telefone:"",
        isLoading: false
      }
    }
  },
  components: {
    MeuLoginBlocoFlutuanteComponent,
    LogoEmpresa,
    NavBarOnly
  },
  mounted() {
    this.VerificarEmpresa();
    window.scrollTo(0, 0);
    ObterClienteLogado().then(res=>{
      this.cliente = res;
    }).catch(err=>{
      console.log('erro')
    });
  },
  methods: {
    async VerificarEmpresa()
    {
        this.isLoading = true;
        this.$store.commit('empresaUrl', this.$router.currentRoute.params.empresa);
        await axios.get(this.$store.state.apiUrl + 'empresa/' + this.$store.state.empresa_url)
        .then(res => {
          if(res.data) {
            this.isLoading = false;
            this.$store.commit('empresa', res.data);
            this.empresaExiste = true;
          }
        })
        .catch(error => this.isLoading = false);

        if(!this.empresaExiste){
          window.open(this.retorno.empresa.empresa_url, '_blank');
        }
       
          
    },
    async Sair() {
      await Logout();
      this.$router.push("/" + this.$store.state.empresa_url);
    },
    UltimosPedidos() {
      this.$router.push("/" + this.$store.state.empresa_url + "/cliente-pedidos");
    }
  }
};
</script>

<style scoped>
@import '../../../assets/css/conteudo-splash.css';
</style>



// WEBPACK FOOTER //
// src/components/Paginas/AreaCliente/PerfilCliente.vue